<!--
/*
 * This file is part of OrangeHRM Inc
 *
 * Copyright (C) 2020 onwards OrangeHRM Inc
 *
 * This program is free software; you can redistribute it and/or modify
 * it under the terms of the GNU General Public License as published by
 * the Free Software Foundation; either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program.  If not, see  http://www.gnu.org/licenses
 */
-->

<template>
  <path
    class="cls-1"
    d="M 166.539 200.601 C 199 163.911 244 139.623 293.462 132.107 C 317.616 57.281 248.577 -14.694 169.154 2.596 C 89.731 19.85 59.5 113.41 114.77 170.982 C 128.693 185.496 146.654 195.751 166.539 200.601 Z M 115.385 333.148 C 115.385 300.974 123.308 269.281 138.462 240.588 L 57.693 240.588 C 25.846 240.588 0 265.468 0 296.124 L 0 314.636 C 0 381.279 59.616 449.774 162.308 462.732 C 131.616 426.041 115.039 380.243 115.385 333.148 Z M 500 333.148 C 500 461.4 355.77 541.557 240.385 477.431 C 125 413.305 125 252.991 240.385 188.865 C 266.693 174.24 296.539 166.539 326.923 166.539 C 422.616 166.354 500.231 241.069 500 333.148 Z M 417.308 346.106 C 418.923 344.366 420.231 342.367 421.154 340.182 C 421.731 337.887 421.731 335.48 421.154 333.148 C 421.731 330.852 421.731 328.446 421.154 326.113 C 420.346 323.818 418.885 321.744 416.923 320.189 L 340 246.141 C 329.654 236.182 311.962 240.736 308.154 254.361 C 306.385 260.692 308.27 267.43 313.077 272.058 L 357.308 314.636 L 250 314.636 C 235.193 314.636 225.962 330.075 233.346 342.404 C 236.77 348.143 243.116 351.66 250 351.66 L 357.308 351.66 L 313.462 394.238 C 303.116 404.234 307.846 421.265 322 424.894 C 328.577 426.597 335.577 424.783 340.385 420.155 L 417.308 346.106 Z"
  />
</template>
